<template>
  <div class="ts-capture_content_container ts-signup-portal">
    <header>
      <h4>Your {{ $t("uorganization") }}</h4>
    </header>

    <el-form @submit.native.prevent>
      <p>Please choose your {{ $t("lorganization") }} sector from the list.</p>
      <el-form-item
        :error="retrieveFieldError(modelState, 'organisationSector.selectedOrganisationSector')"
        :required="true"
      >
        <el-select
          v-model="selectedLevel1Sector"
          v-on:change="loadNaicsLevel2()"
          placeholder="Please select your sector"
        >
          <el-option
            v-for="item in naicsLevel1Options"
            :key="item.code"
            :label="item.title"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="selectedLevel1Sector !== null"
        :error="retrieveFieldError(modelState, 'organisationSector.selectedOrganisationSector')"
        :required="true"
      >
        <el-select
          v-model="selectedLevel2Sector"
          v-on:change="loadNaicsLevel3()"
          placeholder="Please select your sector"
        >
          <el-option
            v-for="item in naicsLevel2Options"
            :key="item.code"
            :label="item.title"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="selectedLevel2Sector !== null"
        :error="retrieveFieldError(modelState, 'organisationSector.selectedOrganisationSector')"
        :required="true"
      >
        <el-select
          v-model="selectedLevel3Sector"
          placeholder="Please select your sector"
        >
          <el-option
            v-for="item in naicsLevel3Options"
            :key="item.code"
            :label="item.title"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>

      <div class="form-actions">
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-white"
        >
          Back
        </button>
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-secondary"
        >
          Next
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  created() {
    if (this.currentRegistration.organisationSector == null) {
      this.currentRegistration.organisationSector = {};
    }

    this.$store.dispatch("onet/getSectorsByCodes", {}).then((res) => {
      this.naicsLevel1Options = res;
    });
  },
  methods: {
    loadNaicsLevel2() {
      this.selectedLevel2Sector = null;
      this.selectedLevel3Sector = null;

      this.$store
        .dispatch("onet/getSectorsByCodes", { levelOneFilter: this.selectedLevel1Sector })
        .then((res) => {
          this.naicsLevel2Options = res;
        });
    },
    loadNaicsLevel3() {
      this.selectedLevel3Sector = null;

      this.$store
        .dispatch("onet/getSectorsByCodes", {
          levelOneFilter: this.selectedLevel1Sector,
          levelTwoFilter: this.selectedLevel2Sector,
        })
        .then((res) => {
          this.naicsLevel3Options = res;
        });
    },
    storeSection() {
      this.isLoading = true;

      this.currentRegistration.organisationSector.selectedOrganisationSector = this.selectedLevel3Sector;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then(() => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.modelState = res.errors;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
  data() {
    return {
      naicsLevel1Options: {},
      naicsLevel2Options: {},
      naicsLevel3Options: {},
      selectedLevel1Sector: null,
      selectedLevel2Sector: null,
      selectedLevel3Sector: null,
      modelState: {},
    };
  },
};
</script>

<style lang="scss"></style>
